import React, { useEffect } from "react";
import Html from "utils/Html";
import { Dropdown } from "semantic-ui-react";
import { useAlluser } from "context/AlluserContext";

export default function FilterActive({ data }) {
  const { filters, storeFilters } = useAlluser();
  const filterName = "active";
  const filterTitle = "Status";

  let handleEvents = {
    OnChange: function (evt, { name, value }) {
      // console.log(name, value);
      storeFilters({ ...filters, active: value });
    },
  };

  useEffect(() => {}, []);

  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={false}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(data, {
          id: "",
          key: filterName,
          name: "name",
          value: "value",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.active ?? ""}
        onChange={handleEvents.OnChange}
        disabled={false}
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
